const actionTypeIdentifier = 'DA9BB9EE-7E9F-4AF0-A2E0-7BA35A7E765E';

export const getVendorDetails = `GET-VENDOR-DETAILS-${actionTypeIdentifier}`;
export const getRateCardUploadTypes = `GET-RATE-CARD-UPLOAD-TYPES-${actionTypeIdentifier}`;
export const setRateCardUploadError = `SET-RATE-CARD-UPLOAD-ERROR-${actionTypeIdentifier}`;

export const RateCardUploadModel = {
    vendorId: 0,
    rateCardUploadTypeId: 0,
    files: []
}